export enum InstallationComponentId {
  VIRTUAL_ASSISTANT_SETUP = "virtual-assistant-setup",
  ECOMMERCE_PAYPAL_SETUP = "ecommerce-paypal-setup",
  ECOMMERCE_STRIPE_SETUP = "ecommerce-stripe-setup",
}
